module.exports = __webpack_public_path__ + "img/ahorcado4.ff5c1e6d.jpg";